export default __webpack_public_path__ + "static/media/tennis-racket-icon.80eba72b.svg";